import { LanguageType } from '@/custom-types';
import { useUserLanguage } from '@/customHooks';
import styled from 'styled-components';

type RentModeMapperPillProps = {
  isForRentWhole: boolean
}

const PillContainer = styled.div<{ $color: string, $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 3rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: bold;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const modeMapping = (isForRentWhole: boolean, language: LanguageType) => {
  const greenStyle = {
    color: {
      font: '#4a9462',
      background: '#d2f3dc'
    }
  };

  const mapping = {
    en: {
      whole: { text: 'Whole', ...greenStyle },
      partial: { text: 'Partial', ...greenStyle }
    },
    es: {
      whole: { text: 'Entera', ...greenStyle },
      partial: { text: 'Parcial', ...greenStyle }
    },
  };

  return isForRentWhole ? mapping[language].whole : mapping[language].partial;
};

export const RentModeMapperPill = ({ isForRentWhole }: RentModeMapperPillProps) => {
  const userLanguage = useUserLanguage()

  const modeMapped = modeMapping(isForRentWhole, userLanguage)
  return (
    <PillContainer $color={modeMapped.color.font} $backgroundColor={modeMapped.color.background}>
      {modeMapped.text}
    </PillContainer>
  );
}
